import axios from 'axios';
import { useState, useEffect } from 'react';
import { Link } from "react-router"
import stylesSheet from '../Components/Sheet.module.scss';
import styles from './MainPage.module.scss';
import { offersApiUrl } from '../user-config';
import { CardOffer } from '../Components/CardOffer';
import { OfferType } from '../App';



export const MainPage = () => {

  const [offers, setOffers] = useState<OfferType[]>([]);

  useEffect(() => {
    axios.get(`${offersApiUrl}`)
      .then(res => {
        setOffers(res.data);
      })
      .catch(error => console.log(error));
  }, [setOffers]);


  return (
    <div className={styles.wrapper}>
      <div className={stylesSheet.Sheet + " " + styles.MainPage}>

        <div className={styles.LinkBlock}>
          <Link
            className={styles.Link}
            to={{
              pathname: "/",
            }}
          ><p>Создать коммерческое предложение</p>
          </Link>
        </div>

        <div className={styles.LinkBlock}>
          <Link
            className={styles.Link}
            to={{
              pathname: "/calc",
            }}
          ><p>Калькулятор</p>
          </Link>
        </div>

        <p className={styles.title}>Готовые КП:</p>

        {offers.sort((a, b) => b.offerId.localeCompare(a.offerId)).map((offer, index) => {
          return (
            <CardOffer
              key={index}
              index={index}
              offer={offer}
              setOffers={setOffers}
            />
          )
        })}

      </div >
    </div>

  )
}
